// src/pages/ProductDetails/SolarReady.jsx
import React from 'react';

import './InverterShared.css';
import './SolarReady.css';
const SolarReady = () => {
  return (
    <section className="apple-section">
      <div className="solar-section">
        <div className="solar-content">
          <div className="solar-icon">☀️</div>
          <h2 className="solar-title">Solar Ready. Future Proof.</h2>
          <p className="solar-text">
            Take your home off the grid. The Zynventics Inverter seamlessly integrates with external MPPT or PWM solar charge controllers. Upgrade to solar whenever you're ready without changing your base setup.
          </p>
          <div className="solar-features">
            <div className="solar-feat-item">
              <span style={{color: '#d97706'}}>✔</span> Grid Savings
            </div>
            <div className="solar-feat-item">
              <span style={{color: '#d97706'}}>✔</span> Eco-Friendly
            </div>
            <div className="solar-feat-item">
              <span style={{color: '#d97706'}}>✔</span> Easy Integration
            </div>
            <div className="solar-feat-item">
              <span style={{color: '#d97706'}}>✔</span> Priority Charging
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolarReady;